import { AfterViewInit, Component, ElementRef, Input, OnDestroy, OnInit, ViewChild, PLATFORM_ID, Inject } from '@angular/core';
import { Subscription } from 'rxjs';

import { SlickCarouselModule } from 'ngx-slick-carousel';
import { CommonModule, DOCUMENT, isPlatformBrowser } from '@angular/common';
import { TrustPilotComponent } from '../trust-pilot/trust-pilot.component';
@Component({
  selector: 'app-common-companies-panel',
  templateUrl: './companies-panel.component.html',
  styleUrls: ['./companies-panel.component.scss'],
  standalone: true,
  imports: [CommonModule, SlickCarouselModule, TrustPilotComponent],
})
export class CommonCompaniesPanelComponent implements OnInit, OnDestroy {
  @Input() companiesData: any;
  @ViewChild('gliderElement') gliderElement!: ElementRef;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {
    this.subscriptions = [];
  }

  ngOnDestroy(): void {
    if (this.subscriptions && this.subscriptions.length > 0) {
      this.subscriptions.forEach(subscription => {
        subscription.unsubscribe();
      });
    }
  }
  subscriptions: Subscription[];
  _companiesData: any;

  ngOnInit(): void {
    this._companiesData = this.companiesData;
  }
  ngOnChanges(): void {
    this._companiesData = this.companiesData;
  }

  slideConfig = {
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 2000,
    variableWidth: true,
    centerMode: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 3,
        },
      },
    ],
  };
}
